var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgBack15X = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14px",
  height: "25px",
  viewBox: "0 0 14 25",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "584CECCB-9734-43A7-81BF-D41A19107EB5@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Schools/Web-SinglePlayer",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Schools/Lessons/SinglePlayer",
  transform: "translate(-321.000000, -225.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "08)-Icon/1)-Default/Back",
  transform: "translate(321.000000, 225.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4.46714997,6.22806276 L6.51089184,17.8156791 M17.7634482,7.18997501 L6.55774136,17.8200633",
  id: "Down",
  transform: "translate(6.500000, 12.172212) rotate(-270.000000) translate(-6.500000, -12.172212) "
}))))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgBack15X);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Back@1.5x.e12c462e19c5717c221f24817870ef41.svg";